import { useMemo } from 'react';
import {
  CovalyntLogoLarge,
  CovalyntLogoSmall,
  Stack,
  useBreakpoints,
  useSideNavExpanded,
  useTheme,
} from 'ui';
import {
  ListBox,
  LogoBox,
  SidebarBox,
  StyledMenuOpenIcon,
} from './MainSideNavbarContent.styles';
import { SIDENAVBAR_CONTENT_WRAPPER } from './SideNavbar.testIds';
import { useMainSideNavbarNavItems } from './useMainSideNavbarNavItems';

export interface MainSideNavbarContentProps {
  readonly onClose?: () => void;
}

export function MainSideNavbarContent({ onClose }: MainSideNavbarContentProps) {
  const theme = useTheme();
  const expanded = useSideNavExpanded();
  const { isMdUp } = useBreakpoints();
  const mainSideNavbarNavItems = useMainSideNavbarNavItems();

  const getSideNavbarBoxContent = useMemo(() => {
    if (expanded) {
      return (
        <LogoBox>
          <CovalyntLogoLarge
            aria-label="Covalynt Logo"
            color={theme.palette.paper[200]}
          />
          {!isMdUp && (
            <StyledMenuOpenIcon aria-label="menu-open-icon" onClick={onClose} />
          )}
        </LogoBox>
      );
    }
    return (
      <LogoBox>
        <CovalyntLogoSmall
          aria-label="Covalynt Logo"
          color={theme.palette.paper[200]}
        />
      </LogoBox>
    );
  }, [expanded, theme.palette.paper, isMdUp, onClose]);

  return (
    <Stack data-testid={SIDENAVBAR_CONTENT_WRAPPER} width="100%">
      <SidebarBox>{getSideNavbarBoxContent}</SidebarBox>
      <ListBox>{mainSideNavbarNavItems}</ListBox>
    </Stack>
  );
}
